class VliscoCart {
    constructor() {
        this.fetchConfig = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        this.classes = {
            active: 'active',
            loading: 'loading',
            tab: 'vlisco-cart__tab',
            cart: 'vlisco-cart__wrapper',
            cartItem: 'vlisco-cart-item',
            message: 'vlisco-cart__message',
            overlay: 'vlisco-cart__overlay',
            input: 'vlisco-cart-item__input',
            tabCart: 'vlisco-cart__tab--cart',
            cartTrigger: 'vlisco-cart__trigger',
            counter: 'vlisco-cart__counter--cart',
            dropdown: 'vlisco-cart-item__dropdown',
            content: 'vlisco-cart__content-wrapper',
            plusBtn: 'vlisco-cart-item__button--plus',
            minusBtn: 'vlisco-cart-item__button--minus',
            removeBtn: 'vlisco-cart-item__button--remove'
        };

        this.cart = document.querySelector(`.${ this.classes.cart }`);
        this.tabs = document.querySelectorAll(`.${ this.classes.tab }`);
        this.cartTab = document.querySelector(`.${ this.classes.tabCart }`);
        this.overlay = document.querySelector(`.${ this.classes.overlay }`);
        this.content = document.querySelector(`.${ this.classes.content }`);
        this.counters = document.querySelectorAll(`.${ this.classes.counter }`);
        this.cartTriggers = document.querySelectorAll(`.${ this.classes.cartTrigger }`);

        this.init();
        this.staticEventListener();
        this.updateEstimatedDelivery(document);

    }

    init() {
        this.message = document.querySelector(`.${ this.classes.message }`);
        this.dropdowns = document.querySelectorAll(`.${ this.classes.dropdown }`);
        this.plusButtons = document.querySelectorAll(`.${ this.classes.plusBtn }`);
        this.minusButtons = document.querySelectorAll(`.${ this.classes.minusBtn }`);
        this.removeButtons = document.querySelectorAll(`.${ this.classes.removeBtn }`);

        this.dynamicEventListener();
        document.addEventListener('minicart:refresh-open', () => this.reloadCartAndOpen());
    }

    staticEventListener() {
        this.overlay.addEventListener('click', () => this.closeMinicart());

        this.tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                this.tabs.forEach(tab => tab.classList.remove(this.classes.active));

                tab.classList.add(this.classes.active);
            });
        });

        this.cartTriggers.forEach(cartTrigger => {
            cartTrigger.addEventListener('click', event => {
                event.preventDefault();

                if (this.cart.classList.contains(this.classes.active)) {
                    this.closeMinicart();
                } else {
                    this.cartTab.click();
                    this.openMinicart();
                }
            });
        });

        document.addEventListener('open-cart', () => this.openMinicart());
        document.addEventListener('update-cart', async event => {
            const data = await this.updateQty(event, event.detail.cartLine, event.detail.response.quantity, false);

            this.responseHandler(data);
        });
    }

    updateEstimatedDelivery(doc) {
        const parentEl = doc.querySelector('.vlisco-cart__estimate');
        const dateEl = parentEl?.querySelector('[data-date]');
        const minMaxDeliveryDays = dateEl?.dataset?.minMax?.trim() || undefined;

        if (!minMaxDeliveryDays) {
            parentEl?.classList.add('opacity-0 pointer-events-none');
        }

        const min = minMaxDeliveryDays?.split('-')[0];
        const max = minMaxDeliveryDays?.split('-')[1];

        if (!min || !max) return;

        const fromDate = this.getEstimatedDeliveryDate(new Date(), min);
        const toDate = this.getEstimatedDeliveryDate(new Date(), max);

        dateEl.innerText = `${ fromDate } - ${ toDate }`;
    }

    getEstimatedDeliveryDate(startDate, days) {
        const dayOfTheWeek = startDate.getDay();
        let daysToAdd = parseInt(days, 10);

        if (dayOfTheWeek == 0)
            daysToAdd++;
        if (dayOfTheWeek + daysToAdd >= 6) {
            const remainingWorkDays = daysToAdd - (5 - dayOfTheWeek);

            daysToAdd += 2;

            if (remainingWorkDays > 5) {
                daysToAdd += 2 * Math.floor(remainingWorkDays / 5);

                if (remainingWorkDays % 5 == 0) {
                    daysToAdd -= 2;
                }
            }
        }

        startDate.setDate(startDate.getDate() + daysToAdd);

        const dateParts = startDate.toString().split(' ');
        return `${ dateParts[0] }, ${ dateParts[1] } ${ dateParts[2] }`;
    }

    dynamicEventListener() {
        const dropdownValues = {};

        this.dropdowns.forEach(dropdown => {
            dropdown.addEventListener('focus', () => {
                dropdownValues[dropdown.dataset.index] = {
                    id: [...dropdown.children].filter(option => option.value === dropdown.value)[0].dataset.id,
                    value: dropdown.value
                }
            });

            dropdown.addEventListener('change', async event => {
                const currentIndex = dropdown.dataset.index;
                const variantsData = JSON.parse(document.querySelector(`.vlisco-cart-item__data--${ currentIndex }`).innerText);
                const selectedTitle = [...dropdown.closest(`.${ this.classes.cartItem }`).querySelectorAll(`.${ this.classes.dropdown }`)].map(dropdown => dropdown.value).join(' / ');
                const newProductId = variantsData.filter(({ title }) => title === selectedTitle)[0].id;
                const currentProductId = dropdownValues[currentIndex].id;
                const { items } = await this.getCart();
                const cartItem = items.filter(({ id }) => id == newProductId)[0];
                const currentQuantity = items.filter(({ id }) => id == currentProductId)[0].quantity;
                let data;

                if (cartItem) {
                    const index = document.querySelector(`.${ this.classes.dropdown }:not([data-index='${ currentIndex }']) option[data-id='${ newProductId }']`).parentElement.dataset.index;
                    const quantity = cartItem.quantity + currentQuantity;

                    data = await this.updateQty(event, index, quantity, true);

                    if (data.message) {
                        dropdown.value = dropdownValues[currentIndex].value;
                        this.responseHandler(data);

                        return;
                    }

                    data = await this.updateQty(event, currentIndex, 0, true);
                } else {
                    data = await this.updateQty(event, currentIndex, 0, true);

                    if (data.message) {
                        dropdown.value = dropdownValues[currentIndex].value;
                        this.responseHandler(data);

                        return;
                    }

                    data = await this.addToCart(newProductId, currentQuantity);

                    if (data.message) {
                        const { items } = await this.getCart();

                        if (items.length) {
                            const updatedQuantity = items.filter(({ id }) => id == newProductId)[0].quantity;

                            document.querySelector(`.${ this.classes.input }--${ currentIndex }`).value = updatedQuantity;
                        }
                    }
                }

                dropdownValues[dropdown.dataset.index] = {
                    id: newProductId,
                    value: dropdown.value
                }

                this.responseHandler(data);
            });
        });

        this.removeButtons.forEach(removeBtn => {
            removeBtn.addEventListener('click', async event => {
                const data = await this.updateQty(event, removeBtn.dataset.index, 0, true);

                this.responseHandler(data);
            });
        });

        this.minusButtons.forEach(minusBtn => {
            minusBtn.addEventListener('click', async event => {
                const quantity = parseInt(minusBtn.dataset.value, 10) - 1;

                if (!quantity) return;

                const data = await this.updateQty(event, minusBtn.dataset.index, quantity, true);
                const quantityElement = minusBtn.closest(`.vlisco-cart-item__counter`).querySelector('input');

                this.responseHandler(data, quantityElement);
            });
        });

        this.plusButtons.forEach(plusBtn => {
            plusBtn.addEventListener('click', async event => {
                const data = await this.updateQty(event, plusBtn.dataset.index, parseInt(plusBtn.dataset.value, 10) + 1, true);
                const quantityElement = plusBtn.closest(`.vlisco-cart-item__counter`).querySelector('input');

                this.responseHandler(data, quantityElement);
            });
        });
    }

    openMinicart() {
        this.cart.classList.add(this.classes.active);
    }

    closeMinicart() {
        this.cart.classList.remove(this.classes.active);
    }

    toggleLoader(state) {
        this.cart.classList[state ? 'add' : 'remove'](this.classes.loading);
    }

    async getCart() {
        const response = await fetch('/cart.js');

        return await response.json();
    }

    async addToCart(id, quantity) {
        const response = await fetch('/cart/add.js', {
            ...this.fetchConfig,
            body: JSON.stringify({
                sections: 'header',
                items: [
                    {
                        id,
                        quantity
                    }
                ]
            })
        });

        return await response.json();
    }

    async updateQty(event, cartLine, quantity, isLoader) {
        event.preventDefault();

        if (isLoader) this.toggleLoader(true);

        const response = await fetch('/cart/change.js', {
            ...this.fetchConfig,
            body: JSON.stringify({
                line: cartLine,
                quantity: quantity,
                sections: 'header'
            })
        });

        return await response.json();
    }

    responseHandler(data, quantityElement) {
        if (data.message) {
            this.errorHandler(data.message);
        } else {
            document.dispatchEvent(
                new CustomEvent("cart-updated", {
                    detail: {
                        element: quantityElement,
                        response: data,
                    },
                }),
            );

            this.successHandler(data);
        }
    }

    errorHandler(message) {
        this.toggleLoader(false);

        this.message.innerText = message;

        setTimeout(() => this.message.innerText = '', 6000);
    }

    successHandler(data) {
        if (!data.sections.header) return;

        const doc = new DOMParser().parseFromString(data.sections.header, 'text/html');
        const updatedCart = doc.querySelector(`.${ this.classes.cart }`);
        const updatedCounter = updatedCart.querySelector(`.${ this.classes.counter }`);
        const updatedContent = updatedCart.querySelector(`.${ this.classes.content }`);
        const counterValue = updatedCounter?.innerHTML.trim() || 0;

        this.updateEstimatedDelivery(updatedContent);

        this.content.innerHTML = updatedContent ? updatedContent.innerHTML : '';
        this.counters.forEach(counter => {
            if (counter.classList.contains('trigger')) {
                counter.innerHTML = counterValue == 0 ? '' : counterValue;
            } else {
                counter.innerHTML = counterValue;
            }
        });

        this.init();
        this.toggleLoader(false);

        document.dispatchEvent(new CustomEvent('update-wishlist'));
        document.dispatchEvent(new CustomEvent('gtm:initialize-minicart'));
    }

    async reloadCartAndOpen() {
        const html = await fetch('/?section_id=header').then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const updatedCart = doc.querySelector(`.${this.classes.cart}`);
        const updatedContent = updatedCart.querySelector(`.${this.classes.content}`);
        const updatedCounter = updatedCart.querySelector(`.${this.classes.counter}`);

        this.content.innerHTML = updatedContent ? updatedContent.innerHTML : '';

        const counterValue = updatedCounter?.innerHTML.trim() || 0;
        this.counters.forEach(counter => counter.innerHTML = counterValue);

        this.updateEstimatedDelivery(updatedContent);
        this.init();

        this.openMinicart();
    }
}

document.addEventListener('DOMContentLoaded', () => new VliscoCart());
